<template>


        <div id="progress">
            <v-layout row wrap class="justify-center">

                <v-flex xs1 class="counter">
                    <v-badge right color="cyan" overlap>
                        <span v-if="count > 0" slot="badge">{{count}}</span>
                        <v-icon
                                large
                                color="yellow lighten-1"
                        >
                            star
                        </v-icon>
                    </v-badge>

                </v-flex>

                <v-flex v-for="index in 7" :key="index" xs1>
                    <img v-if="progress >= index" src="/images/full.svg" alt="">
                    <img v-else src="/images/empty.svg" alt="">
                </v-flex>
            </v-layout>
        </div>

    
</template>

<script>
    export default {
        name: "starorder-progress",
        props: {
            progress: {
                default: 0
            },
            count: {
                default: 0
            }
        },

    }
</script>

<style scoped>
   #progress {
       background-color: #3d6983;
       border-radius: 3em;
   }
    .counter {
        justify-content: center;
        align-items: center;
        display: flex;
    }
</style>